/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droprulesempty2Inputs */

const en_droprulesempty2 = /** @type {(inputs: Droprulesempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No rules - this drop is open to everyone.`)
};

const de_droprulesempty2 = /** @type {(inputs: Droprulesempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Regeln – dieser Drop ist für alle offen.`)
};

/**
* | output |
* | --- |
* | "No rules - this drop is open to everyone." |
*
* @param {Droprulesempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droprulesempty2 = /** @type {((inputs?: Droprulesempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droprulesempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droprulesempty2(inputs)
	return de_droprulesempty2(inputs)
});
export { droprulesempty2 as "dropRulesEmpty" }